/* ローディング画面 */
import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';
var LoadingModal = function (_a) {
    var show = _a.show;
    return (React.createElement(Modal, { id: "loading-modal", size: "lg", centered: true, show: show, animation: false, onHide: function () { } },
        React.createElement(Spinner, { animation: "border", role: "status" })));
};
export default LoadingModal;
